export { MessageContentWithMentionsFragment } from "@outschool/ui-components-classroom";

import { MessageContentFragment } from "@outschool/ui-components-classroom";

export default MessageContentFragment;
